// Display section names as configured in the map config attribute groups
export const DISPLAY_SECTIONS = {
    HEADER: 'Header Section',
    ASSET: 'Asset Section',
    OWNER: 'Owner Section'
};

export const OWNER_INFORMATION_GROUP_NAME = 'Owner Information';

// English display names of the attribute that holds the asset owner's name
export const ASSET_OWNER_NAME_ATTRIBUTE_NAMES = ['Data provider', 'Asset Owner'];
